import * as React from 'react';
import { ArticleSubscriber } from '../../../../../amorg-common';
import { Button } from '../../../../../designSystem/button/Button';
import { AnimatedCollapsibleContent } from '../../../../../designSystem/collapsible/AnimatedCollapsibleContent';
import { Flex } from '../../../../../designSystem/compositeComponents/FlexHelpers';
import { H3 } from '../../../../../designSystem/typography/Heading';
import { Pill } from '../../../../../designSystem/pill/Pill';
import { TextAvatar } from '../../../../../designSystem/avatar/TextAvatar';


type ArticleViewSubscriberPanelProps = {
    subscribers: ArticleSubscriber[];
};
export function ArticleViewSubscriberPanel (props: ArticleViewSubscriberPanelProps): JSX.Element
{
    const [show, setShow] = React.useState<boolean>(false);

    React.useEffect(() =>
    {
        setShow(props.subscribers.length < 8);
    }, [props.subscribers]);

    return (
        <Flex flexDirection="column">
            <Flex>
                <Flex gap={8} style={{ flexGrow: 1 }}>
                    <H3>Abonnenter</H3>
                    <TextAvatar text={props.subscribers.length.toString()} size='24px' />
                </Flex>
                <Button variant='text' icon={show ? 'caret_caretUp' : 'caret_caretDown'} onClick={() => setShow(!show)} />
            </Flex>
            <AnimatedCollapsibleContent open={show}>
                <Flex flexDirection='row' gap={8} style={{ flexGrow: 1, flexWrap: 'wrap' }}>
                    {props.subscribers.map((s) =>
                    {
                        return (
                            <Pill key={s.subscriberId} identifier={s.subscriberId}>
                                {s.companyName || s.siteId}
                            </Pill>
                        );
                    })}
                </Flex>

            </AnimatedCollapsibleContent>
        </Flex>
    );
}